/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SummarizeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Summarize',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="24" x="6" y="2" />
    <rect height="4" rx="1" ry="1" width="24" x="6" y="18" />
    <rect height="4" rx="1" ry="1" width="32" x="2" y="10" />
    <path
      d="M19.5 34a.5.5 0 0 0 .5-.5V30h2.793a.5.5 0 0 0 .354-.854L18 24l-5.146 5.146a.5.5 0 0 0 .354.854H16v3.5a.5.5 0 0 0 .5.5Z"
    />
  </svg>`;
};
